export default {
  reports: {
    actions: {},
    dataTable: {
      headers: {
        modified: "Modificado",
        name: "Nombre",
        tenant: "Inquilino"
      },
      noResultsText: "No hay informes coincidentes"
    },
    itemName: "informe"
  }
}
